export default "__VITE_ASSET__BfC7WS3S__"